import { dataApiUrl } from '../url';
import AuthAxios from '../auth-axios';

const DataApiUrl = dataApiUrl() + '/home';

const Home = () => {
  const getWorkshops = () =>
    AuthAxios.get(`${DataApiUrl}/workshops`)
      .then(res => res.data.data.results)
      .catch(err => console.error(err.message));

  return {
    getWorkshops,
  };
};

export default Home;
